import React from "react";
import LocationIcon from "components/Icons/LocationIcon";
import DateIcon from "components/Icons/DateIcon";
import ClockIcon from "components/Icons/ClockIcon";
import Link from "next/link";
import { format } from "date-fns";
import { withImageResizer } from "lib/utils";

const GridItemSmallScreens = ({ item, isUpcoming }) => {
  return (
    <div
      key={item?.title}
      className="group mx-1 w-full mr-2 transition-all duration-200 ease-linear delay"
    >
      {item && (
        <Link
          href={`/?eventSlug=${item?.urlName}&accountSlug=${item?.account?.urlName}`}
          as={`/kirkko/${item?.account?.urlName}/${item?.urlName}`}
        >
          <a className="w-full">
            <div className="rounded-lg">
              <img
                role="img"
                alt={"Kuva " + item?.title}
                className="rounded-lg w-full h-206 object-cover object-bottom tablet:h-[150px] bg-gray-100"
                src={
                  item?.previewImg
                    ? withImageResizer(item.previewImg, 640)
                    : "/images/bg1.jpeg"
                }
              />
              <article className="rounded-br-10 rounded-bl-10 bg-white-100  flex items-center pt-4 pr-1">
                <div className="flex w-full">
                  <div className="flex items-start flex-col w-full">
                    <div className="flex justify-start items-start w-full">
                      <h2 className="font-bold text-left bg-white-100 flex items-center justify-between">
                        <div className="text-bodyText origin-left truncate-text two-lines">
                          {item?.title}
                        </div>
                      </h2>
                    </div>
                    <div className="flex items-center w-full">
                      <div className="flex justify-center flex-col">
                        <div className="flex items-center">
                          <LocationIcon />
                          <span className="px-2.5 pb-0.5 text-gray text-sm font-bold">
                            {item?.account?.name}
                          </span>
                        </div>
                        <div className="flex justify-start">
                          <div className="flex items-center p-2.5 pt-0 pl-0">
                            <ClockIcon width={11.85} height={11.85} />
                            <span className="text-gray text-sm font-bold pl-2">
                              {item?.publishingDate &&
                                format(
                                  new Date(item?.publishingDate).getTime(),
                                  "HH.mm"
                                )}
                            </span>
                          </div>
                          <div className="flex items-center p-2.5 pt-0 pl-0">
                            <DateIcon />
                            <span className="text-gray text-sm font-bold pl-2">
                              {item.publishingDate &&
                                format(
                                  new Date(item.publishingDate).getTime(),
                                  "dd.MM.yyyy"
                                )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </a>
        </Link>
      )}
    </div>
  );
};

export default GridItemSmallScreens;
